import EditorInput from "components/ui/EditorInput";

// Rich-text editor styled to the DS spec (attached toolbar + body, error frame).
// `className` is forwarded to the underlying editor (e.g. "hide-toolbar");
// the DS frame styling lives on the wrapper.
export default function RichText({ error = false, wrapperClassName = "", "data-testid": testId, ...rest }) {
  return (
    <div className={`peb-richtext ${error ? "peb-richtext--error" : ""} ${wrapperClassName}`} data-testid={testId}>
      <EditorInput {...rest} />
    </div>
  );
}
